module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2a"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rint"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Introduction#int"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction#int"
    }
  }, [_vm._v("FERESHTEH NOURAIE-SIMONE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter01#ch1"
    }
  }, [_vm._v("The Shipwrecked")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter01#ch1"
    }
  }, [_vm._v("MONIRU RAVANIPOUR")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Maid")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOLI TARAGHI")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mermaid Café")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MITRA ELIYATI")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unsettled, Unbound")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FARIBA VAFI")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Burnt Sound")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BEHNAZ ALIPOUR GASKARI")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intercession")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MITRA DAVAR")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Bloody Day of Ashura")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MASIH ALINEJAD")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bathhouse")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHAHLA ZARLAKI")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wandering Cumulus Cloud")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ZOHREH HAKIMI")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grammar")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOFIA MAHMUDI")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch11"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dogs and Humans")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FERESHTEH MOLAVI")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch12"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Queue")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHIVA ARASTOUIE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch13"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tehran")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MONIRU RAVANIPOUR")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb",
    attrs: {
      "id": "rack"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb",
    attrs: {
      "id": "redit"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Editor#edit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Editor")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb",
    attrs: {
      "id": "ravailable"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Publisher#available",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also Available from Feminist Press")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rfemi"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Publisher1#femi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About Feminist Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb868e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0